import { fetch } from "graphql-helper";

export function getSites() {
  return fetch(`
    query {
      sites {
        id
        name
        parentSite {
          id
          name
        }
      }
    }
  `);
}
